import type { CountryCode } from '@/features/user/types/types';
import { getSupportedCountries } from '@/lib/utils';

export const COUNTRY_CODES: CountryCode[] = getSupportedCountries().map(country => ({
  value: country.code,
  label: country.callingCode
}));

// Gender enum values matching backend
export type Gender = 'MALE' | 'FEMALE' | 'NON-BINARY' | '';

export const GENDER_OPTIONS: { value: Gender; label: string }[] = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  { value: 'NON-BINARY', label: 'Non-Binary' }
];

export const INITIAL_USER_DATA = {
  first_name: "",
  last_name: "",
  dob: "",
  phone_number: {
    country_code: "GB",
    number: ""
  },
  gender: "" as Gender
};

